import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import { Button } from '../../form';

const CTAWrapper = styled('div')`
  text-align: right;
`;

const NotificationCTA = (props) => {
  const { declineButtonMsg, acceptButtonMsg, handleDecline, handleAccept } = props;

  return (
    <CTAWrapper>
      <Button onClick={handleDecline}>{declineButtonMsg}</Button>
      <Button onClick={handleAccept} variant="secondary">
        {acceptButtonMsg}
      </Button>
    </CTAWrapper>
  );
};

NotificationCTA.propTypes = {
  declineButtonMsg: PropTypes.string.isRequired,
  acceptButtonMsg: PropTypes.string.isRequired,
  handleDecline: PropTypes.func.isRequired,
  handleAccept: PropTypes.func.isRequired,
};

export default NotificationCTA;
